import React from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { Content } from '../../infrastructure/content';

export const BackButton = ({ onClick }) => (
  <Content>
    {({ headerBackButtonTitle }) => (
      <NavigationButton.Secondary labelText={headerBackButtonTitle} onClick={onClick} />
    )}
  </Content>
);
